import { styled } from "@mui/material/styles";
import { FormControlLabel } from "@mui/material";

const CustomCheckbox = styled(FormControlLabel)(({ checked }) => ({
  "&.MuiFormControlLabel-root": {
    // minHeight: "66px",
    height: "45px",
    width: "100%",
    border: "1px solid #EBEBEB",
    borderRadius: "10px",
    margin: 0,
    marginBottom: 20,
    padding: "5px 15px",
    flexDirection: "row-reverse",
    justifyContent: "space-between",
  },
  "&:hover": {
    border: "2px solid #5E70CC",
  },
  " &:focus": {
    border: "2px solid #5E70CC",
  },
  "&:checked + .MuiFormControlLabel-root": {
    backgroundColor: "red",
    color: "red",
  },
  "& .MuiFormControlLabel-label": {
    fontWeight: 500,
    fontSize: "20px",
    color: "#1D1E24",
  },
}));
export default CustomCheckbox;
